import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VrcTabsComponent } from './vrc-tabs/vrc-tabs.component';
import { VrcTabComponent } from './vrc-tab/vrc-tab.component';
import { VrCommonModule } from '../../vr-common.module';

const exports = [VrcTabsComponent, VrcTabComponent];

@NgModule({
  declarations: [...exports],
  exports,
  imports: [
    CommonModule,
    VrCommonModule
  ]
})
export class VrcTabsModule { }
